// export const domain = 'http://localhost:8000';
// export const ws_domain = 'ws://localhost:8000';

export const domain = 'https://api.hiket.app';
export const ws_domain = 'wss://api.hiket.app';